import React from 'react'
import ComingSoon from 'components/ComingSoon'

export default function AdminTicketsTable() {
  return(<ComingSoon />)
}
